module.exports = __webpack_public_path__ + "img/p64-chongqing-2002.addd3e4a.jpg";